import React, { Component } from 'react';

export class TruckContactBox extends Component {
  render() {
    if (this.props.truck != null) {
      return(
        <div>

            <div className="col-sm-2">
                <div className="text-center">
                    <img alt="image" className="img-circle m-t-xs img-responsive driver-image" src={this.props.truck.image} onClick={this.props.onOpenDriverPanel} />
                </div>
            </div>
            <div className="col-sm-5">
                <h3><strong>{this.props.truck.plate}</strong></h3>
                <p>{this.props.truck.pilotName}</p>
                <p><button className="btn btn-circle btn-xs" type="button" onClick={this.props.onOpenChatPanel}><i className="fa fa-comments"></i></button> click to chat </p>
            </div>
            <div className="col-sm-5">
                <address>
                    Type: <strong>{this.props.truck.truckType}</strong><br />
                    Tractor: <strong>{this.props.truck.truckModel}</strong><br />
                    {/*Year: <strong>{this.props.truck.truckYear}</strong><br />*/}
                    Max Load: <strong>{this.props.truck.maxCharge} lbs</strong><br />
                    <abbr title="Phone">Phone:</abbr> {this.props.truck.mobile}
                </address>
            </div>
            <div className="clearfix"></div>
        </div>
      );
    } else {
      return <p>Truck not selected</p>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/TruckContactBox.js